export const blockIconsMapsNearMeNew = (
	<span className='material-symbols-outlined'>near_me</span>
);
